<template>
  <div class="px-1 rounded pb-2">
    <TitleButton
        class="mt-1"
        :showBtn="false"
        :showAddNew="false"
        title="Budget Setup"
    >
    </TitleButton>

    <div class="row gy-1">
      <section id="basic-tabs-components">
        <div class="row match-height">
          <div class="col-12">
            <ul class="nav nav-tabs" role="tablist">
              <li
                  class="nav-item"
                  :class="`${props.accountType == tab.id ? 'active' : ''}`"
                  v-for="(tab, i) in tabs"
                  :key="i"
                  @click="onClickTab(tab.id)"
                  type="button"
              >
                <a :class="`${props.accountType == tab.id ? 'active' : ''}`" class="nav-link" data-bs-toggle="tab"
                   aria-controls="home" role="tab" aria-selected="true">{{ tab.name }}</a>
              </li>
            </ul>
          </div>
        </div>
      </section>
    </div>

  </div>

  <div class="card-body">
    <div class="row d-flex flex-wrap justify-content-between align-items-center">
      <TreeBrowser
          :style="{opacity: chartLoading ? .5 : 1}"
          :groupData="groupData"
          :endpointData="endpointData"
          :depth="0"
          :accountType="props.accountType"
          @paginationEmit="handlePaginationEmit"
      />
    </div>
  </div>
</template>

<script setup>
import TreeBrowser from "./TreeBrowser";
import TitleButton from '@/components/atom/TitleButton'
import handleInventory from "@/services/modules/inventory";

const emit = defineEmits(['handleTabChange', 'handleRootPagination'])
const props = defineProps(['tabs', 'groupData', 'endpointData', 'accountType'])
const {chartLoading} = handleInventory();

function onClickTab(tab) {
  emit('handleTabChange', tab)
}

function handlePaginationEmit(page) {
  emit('handleRootPagination', page)
}

</script>